import { render, staticRenderFns } from "./SystemVitals.vue?vue&type=template&id=077f689a&scoped=true"
import script from "./SystemVitals.vue?vue&type=script&lang=js"
export * from "./SystemVitals.vue?vue&type=script&lang=js"
import style0 from "./SystemVitals.vue?vue&type=style&index=0&id=077f689a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077f689a",
  null
  
)

export default component.exports